import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-308e67d9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "head" }
const _hoisted_2 = { class: "left" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "您正在修改", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "中的商品", -1))
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 退出 ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 商品库 ")
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 价格筛选   ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("  到   ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("    ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 筛选 ")
const _hoisted_12 = { class: "spec" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" 删除 ")
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" 已选 ")
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" 添加 ")
const _hoisted_16 = {
  key: 0,
  class: "pagination"
}
const _hoisted_17 = { class: "left" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "每页显示", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "条，共计", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_21 = { class: "carts-count" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" 保存 ")
const _hoisted_23 = { class: "footer" }
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" 暂不保存 ")
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" 确定保存 ")

import { ref, onMounted, watch, reactive, toRefs } from 'vue'
import { $post } from '@/utils/https'
import { Category, Products, Product, PreOrderProducts } from '@/model/product'
import { ElMessage, ElMessageBox } from 'element-plus'
import { useRouter, useRoute } from 'vue-router'
import Header from '@/components/header'
import Asside from '@/components/aside'
interface State {
  carts: Product[]
  tableData: Product[]
  categorys: Category[]
  pageSizeOpt: number[]
}


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const router = useRouter()
const route = useRoute()
const loading = ref(false)
const downloadLoading = ref(false)
const editSelectionDialogVisible = ref(false)
const selectionName = ref('')
const selectionInputName = ref('')

const state = reactive<State>({
  carts: [],
  tableData: [],
  categorys: [
    {
      name: '全部商品库',
      id: 0
    },
    {
      name: '当前选品单',
      id: -1
    }
  ],
  pageSizeOpt: [20, 30, 50]
})
const listId = ref(-1)
const pageSize = ref(20)
const pageIndex = ref(1)
const total = ref(0)
const searchName = ref('')
const id = parseInt(route.query.id as any)
const startPrice = ref()
const endPrice = ref()
onMounted(() => {
  if (isNaN(id)) {
    ElMessage.error('参数错误!')
    return
  }
  $post<PreOrderProducts>({
    url: '/order/selection/detail',
    loading: true,
    data: {
      id: id
    }
  }).then((res) => {
    if (res.data && res.data.product.length > 0) {
      getClassList()
      selectionName.value = res.data.selection_name || '未命名'
      state.carts = res.data.product
      checkListId(-1)
    } else {
      ElMessage.error('商品列表信息错误!')
    }
  })
})
const getClassList = () => {
  $post<Category>({
    url: '/product/classlist',
    data: {}
  }).then((res) => {
    state.categorys.splice(1, 0, ...res.data)
    // getProductList(0, '')
  })
}
watch(
  () => pageSize.value,
  () => {
    if (pageIndex.value === 1) {
      getProductList(listId.value, searchName.value)
      return
    }
    pageIndex.value = 1
  }
)
watch(
  () => pageIndex.value,
  (val: number) => {
    pageIndex.value = val
    getProductList(listId.value, searchName.value)
  }
)

const listIncludeById = (id: number): boolean => {
  return state.carts.filter((item) => item.id === id).length > 0
}
const search = (val: string) => {
  listId.value = 0
  searchName.value = val
  if (pageIndex.value === 1) {
    getProductList(0, val)
  } else {
    pageIndex.value = 1
  }
}
const checkListId = (val: number) => {
  searchName.value = ''
  listId.value = val
  if (val === -1) {
    state.tableData = state.carts
  } else {
    if (pageIndex.value === 1) {
      getProductList(val, '')
    } else {
      pageIndex.value = 1
    }
  }
}
const getProductList = (id?: number, name?: string) => {
  $post<Products>({
    url: '/product/list',
    loading: true,
    data: {
      price_start: startPrice.value >= 0 ? startPrice.value : -1,
      price_end: endPrice.value >= 0 ? endPrice.value : -1,
      product_name: name,
      class_id: id,
      page: pageIndex.value,
      page_size: pageSize.value
    }
  }).then((res) => {
    total.value = res.data.total
    if (res.data.data && res.data.data.length > 0) {
      res.data.data.forEach((row: Product) => {
        row.tags = row.tags ? row.tags.split('|') : []
      })
    }
    state.tableData = [].concat(res.data.data || [])
  })
}
const cellClass = (val) => {
  if (val.column.label === '产品图') {
    return 'i-cell-img-class'
  }
}
const headerCellClass = () => {
  return 'i-header-cell-class'
}
const handleDelete = (index: number) => {
  ElMessageBox.confirm('确定要删除该商品吗?', '提示', {
    confirmButtonText: '删除',
    cancelButtonText: '取消',
    type: 'warning'
  })
    .then(() => {
      state.carts.splice(index, 1)
    })
    .catch(() => {})
}
const handleAdd = (index: number) => {
  const arr = state.carts.filter((item: Product) => {
    return item.id === state.tableData[index].id
  })
  if (arr.length > 0) {
    ElMessage.error('该商品已存在! 请勿重复添加')
    return
  }
  state.carts.push(state.tableData[index])
}

// const handleDownload = () => {
//   if (state.carts.length <= 0) {
//     ElMessage.error('请添加商品')
//     return
//   }
//   downloadLoading.value = true
//   $exportExcel({
//     url: '/order/selection/export',
//     data: {
//       pid: state.carts.map((item) => item.id).join(',')
//     }
//   }).then((res) => {
//     downloadLoading.value = false
//     if (!res.data) return
//     const blob = new Blob([res.data], {
//       type: 'application/vnd.ms-excel;charset=utf8'
//     })
//     const url = window.URL.createObjectURL(blob)
//     const aLink = document.createElement('a')
//     aLink.style.display = 'none'
//     aLink.href = url
//     aLink.setAttribute('download', `选品单${new Date().getTime()}.xlsx`)
//     document.body.appendChild(aLink)
//     aLink.click()
//     ElMessageBox.alert('您已成功下载选品单,可在下载中心查看！', '', {
//       confirmButtonText: '确定',
//       showClose: false,
//       center: true,
//       callback: () => {}
//     })
//     setTimeout(() => {
//       window.URL.revokeObjectURL(url) // 释放URL 对象
//       document.body.removeChild(aLink)
//     }, 500)
//   }).catch((err) => {
//     downloadLoading.value = false
//     if (err.message) {
//       ElMessage.error(err.message)
//     }
//   })
// }
const showEditSelectionDialog = () => {
  if (state.carts.length <= 0) {
    ElMessage.error('请添加商品')
    return
  }
  editSelectionDialogVisible.value = true
  selectionInputName.value = selectionName.value
}
const hideEditSelectionDialog = () => {
  editSelectionDialogVisible.value = false
}
const editSelection = () => {
  if (!selectionInputName.value.trim()) {
    ElMessage.error('请输入客户名称')
    return
  }
  loading.value = true
  $post<any>({
    url: '/order/selection/create',
    data: {
      id: id,
      selection_name: selectionInputName.value,
      product_ids: state.carts.map((item) => item.id).join(',')
    }
  }).then(() => {
    loading.value = false
    hideEditSelectionDialog()
    back()
  })
}
const back = () => {
  router.replace('/selectionHistory')
}

const { carts, tableData, categorys, pageSizeOpt } = toRefs(state)

return (_ctx: any,_cache: any) => {
  const _component_el_header = _resolveComponent("el-header")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_footer = _resolveComponent("el-footer")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_container, { class: "container" }, {
    default: _withCtx(() => [
      _createVNode(_component_el_header, null, {
        default: _withCtx(() => [
          _createVNode(_unref(Header), {
            onSearch: search,
            onNavCart: checkListId,
            cartCount: _unref(carts).length,
            pageName: "productsEdit"
          }, null, 8, ["cartCount"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_container, { style: {"height":"100%","overflow":"hidden"} }, {
        default: _withCtx(() => [
          _createVNode(_unref(Asside), {
            list: _unref(categorys),
            checkId: listId.value,
            onCheckListId: checkListId
          }, null, 8, ["list", "checkId"]),
          _createVNode(_component_el_container, { style: {"background-color":"#f7f7f7"} }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_2, [
                    _createTextVNode(_toDisplayString(listId.value === -1 ? "当前选品单" : "商品库列表") + " ", 1),
                    _hoisted_3,
                    _createElementVNode("span", null, _toDisplayString(selectionName.value), 1),
                    _hoisted_4,
                    _createVNode(_component_el_button, {
                      type: "primary",
                      class: "back",
                      onClick: back
                    }, {
                      default: _withCtx(() => [
                        _hoisted_5
                      ]),
                      _: 1
                    })
                  ]),
                  (listId.value === -1)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 0,
                        loading: downloadLoading.value,
                        type: "primary",
                        class: "download",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (checkListId(0)))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_6
                        ]),
                        _: 1
                      }, 8, ["loading"]))
                    : (_openBlock(), _createBlock(_component_el_button, {
                        key: 1,
                        type: "primary",
                        class: "nav-cart",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (checkListId(-1)))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" 当前已选(" + _toDisplayString(_unref(carts).length) + ") ", 1)
                        ]),
                        _: 1
                      }))
                ]),
                (listId.value !== -1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _hoisted_8,
                      _createVNode(_component_el_input_number, {
                        modelValue: startPrice.value,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((startPrice).value = $event)),
                        step: 1,
                        min: 0,
                        max: 9999,
                        size: "small",
                        style: {"width":"60px"},
                        "step-strictly": "",
                        controls: false
                      }, null, 8, ["modelValue"]),
                      _hoisted_9,
                      _createVNode(_component_el_input_number, {
                        modelValue: endPrice.value,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((endPrice).value = $event)),
                        step: 1,
                        min: 0,
                        max: 9999,
                        size: "small",
                        style: {"width":"60px"},
                        "step-strictly": "",
                        controls: false
                      }, null, 8, ["modelValue"]),
                      _hoisted_10,
                      _createVNode(_component_el_button, {
                        type: "primary",
                        size: "small",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (getProductList(listId.value, searchName.value)))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_11
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", {
                class: "tab",
                style: _normalizeStyle(listId.value === -1 ? 'padding-bottom:20px' : '')
              }, [
                _createVNode(_component_el_table, {
                  data: _unref(tableData),
                  class: "i-table",
                  height: "100%",
                  "empty-text": "暂无数据",
                  "cell-class-name": cellClass,
                  "header-cell-class-name": headerCellClass
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_table_column, {
                      label: "产品名称",
                      "min-width": "200px",
                      prop: "product_name"
                    }, {
                      default: _withCtx((scope) => [
                        _createTextVNode(_toDisplayString(scope.row.product_name) + " ", 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.tags, (item, i) => {
                          return (_openBlock(), _createBlock(_component_el_tag, {
                            size: "small",
                            style: {"margin-right":"4px"},
                            key: i
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item), 1)
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      align: "center",
                      prop: "main_img",
                      label: "产品图"
                    }, {
                      default: _withCtx((scope) => [
                        _createVNode(_component_el_image, {
                          class: "img-url",
                          src: scope.row.main_img,
                          "preview-src-list": [scope.row.main_img],
                          fit: "contain"
                        }, {
                          error: _withCtx(() => [
                            _createVNode(_component_el_image, {
                              src: require('Assets/images/img_product_err_img.png'),
                              fit: "contain"
                            }, null, 8, ["src"])
                          ]),
                          _: 2
                        }, 1032, ["src", "preview-src-list"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, { label: "包装规格" }, {
                      default: _withCtx((scope) => [
                        _createVNode(_component_el_tooltip, {
                          effect: "dark",
                          "show-after": 500,
                          content: 
                    scope.row.type === 2
                      ? (scope.row.volumn || '0') +
                        (scope.row.carton.spec === 1
                          ? ''
                          : '*' + scope.row.carton.spec + scope.row.unit) +
                        '*' +
                        scope.row.carton.name
                      : (scope.row.volumn || '0') + '*' + scope.row.unit
                  
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_12, _toDisplayString(scope.row.type === 2
                        ? (scope.row.volumn || "0") +
                          (scope.row.carton.spec === 1
                            ? ""
                            : "*" + scope.row.carton.spec + scope.row.unit) +
                          "*" +
                          scope.row.carton.name
                        : (scope.row.volumn || "0") + "*" + scope.row.unit), 1)
                          ]),
                          _: 2
                        }, 1032, ["content"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "brand_name",
                      label: "品牌名"
                    }),
                    _createVNode(_component_el_table_column, { label: "单价" }, {
                      default: _withCtx((scope) => [
                        _createTextVNode(_toDisplayString(scope.row.type === 2
                    ? scope.row.carton.price
                    : scope.row.price), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      label: "操作",
                      align: "center"
                    }, {
                      default: _withCtx((scope) => [
                        (listId.value === -1)
                          ? (_openBlock(), _createBlock(_component_el_button, {
                              key: 0,
                              type: "primary",
                              class: "del",
                              onClick: ($event: any) => (handleDelete(scope.$index))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_13
                              ]),
                              _: 2
                            }, 1032, ["onClick"]))
                          : (listIncludeById(scope.row.id))
                            ? (_openBlock(), _createBlock(_component_el_button, {
                                key: 1,
                                type: "info",
                                class: "del"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_14
                                ]),
                                _: 1
                              }))
                            : (_openBlock(), _createBlock(_component_el_button, {
                                key: 2,
                                type: "primary",
                                class: "add",
                                onClick: ($event: any) => (handleAdd(scope.$index))
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_15
                                ]),
                                _: 2
                              }, 1032, ["onClick"]))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["data"])
              ], 4),
              (listId.value !== -1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _hoisted_18,
                      _createVNode(_component_el_select, {
                        modelValue: pageSize.value,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((pageSize).value = $event)),
                        class: "sel-page-size",
                        placeholder: "Select",
                        size: "large"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(pageSizeOpt), (item, i) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: i,
                              label: item,
                              value: item
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _hoisted_19,
                      _createTextVNode(" " + _toDisplayString(total.value) + "件产品 ", 1),
                      _hoisted_20
                    ]),
                    _createVNode(_component_el_pagination, {
                      currentPage: pageIndex.value,
                      "onUpdate:currentPage": _cache[6] || (_cache[6] = ($event: any) => ((pageIndex).value = $event)),
                      "page-size": pageSize.value,
                      "onUpdate:page-size": _cache[7] || (_cache[7] = ($event: any) => ((pageSize).value = $event)),
                      background: "",
                      layout: "prev, pager, next",
                      total: total.value,
                      "pager-count": 6
                    }, null, 8, ["currentPage", "page-size", "total"])
                  ]))
                : _createCommentVNode("", true),
              _withDirectives(_createVNode(_component_el_footer, { class: "foot" }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_21, "共计" + _toDisplayString(_unref(carts).length) + "件商品", 1),
                  _createVNode(_component_el_button, {
                    type: "primary",
                    class: "quotation",
                    onClick: showEditSelectionDialog
                  }, {
                    default: _withCtx(() => [
                      _hoisted_22
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 512), [
                [_vShow, listId.value === -1]
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_dialog, {
        "custom-class": "edit-selection-dialog",
        modelValue: editSelectionDialogVisible.value,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((editSelectionDialogVisible).value = $event)),
        width: "464px",
        title: "是否将本次更改保存到",
        "destroy-on-close": "",
        center: ""
      }, {
        footer: _withCtx(() => [
          _createElementVNode("div", _hoisted_23, [
            _createVNode(_component_el_button, {
              class: "cancel",
              onClick: hideEditSelectionDialog
            }, {
              default: _withCtx(() => [
                _hoisted_24
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              loading: loading.value,
              type: "primary",
              class: "commit",
              onClick: editSelection
            }, {
              default: _withCtx(() => [
                _hoisted_25
              ]),
              _: 1
            }, 8, ["loading"])
          ])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            modelValue: selectionInputName.value,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((selectionInputName).value = $event)),
            placeholder: "请输入客户名称",
            clearable: ""
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}
}

})